// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3xZJk","Label":"BuildControl_Label__1qi_p","Less":"BuildControl_Less__2CWAJ","More":"BuildControl_More__3LRI_"};